import {copilotFeatureFlags} from '@github-ui/copilot-chat/utils/copilot-feature-flags'
import {useChatStateValue} from '@github-ui/copilot-chat/utils/CopilotChatContext'
import {ContentPreview} from '@github-ui/copilot-immersive-v1/components/ContentPreview/ContentPreview'
import {useResourcePanelOpen} from '@github-ui/copilot-immersive-v1/components/ContentPreview/ContentPreviewContext'
import {ResourcePanel} from '@github-ui/copilot-immersive-v1/components/ResourcePanel/ResourcePanel'
import {LayoutContext} from '@github-ui/pacer/Layout/layout-context'
import type {LayoutContextValue} from '@github-ui/pacer/Layout/types'
import {useMemo, useRef} from 'react'

import styles from './EmbeddedContentPreview.module.css'

export function EmbeddedContentPreview({inputRef}: {inputRef: React.RefObject<HTMLTextAreaElement | null>}) {
  const resourcePanelOpen = useResourcePanelOpen()
  const optedInToPreviewFeatures = useChatStateValue('optedInToPreviewFeatures')
  const containerRef = useRef<HTMLDivElement>(null)
  const sidebarRef = useRef<HTMLDivElement>(null)

  const layoutContextValue = useMemo<LayoutContextValue>(
    () => ({
      layoutBreakpoint: false,
      sidebarExpanded: false,
      sidebarVisible: false,
      sidebarCondensable: false,
      toggleSidebar: () => {},
      mainColumn: undefined,
      secondaryColumnVisible: true,
      toggleSecondaryColumn: () => {},
      secondaryColumnFullWidth: false,
      toggleSecondaryColumnFullWidth: () => {},
      resourcePanelOpen,
      toggleResourcePanel: () => {},
      setDesktopLayoutState: () => {},
      slimLineTopTabs: false,
      containerRef,
      sidebarRef,
    }),
    [resourcePanelOpen],
  )

  return (
    <LayoutContext value={layoutContextValue}>
      <div className={styles.contentPreview}>
        {copilotFeatureFlags.copilotResourcePanel && optedInToPreviewFeatures && resourcePanelOpen && (
          <ResourcePanel className="m-0" />
        )}
        <ContentPreview className="m-0" returnFocusRef={inputRef} hideExpandButton />
      </div>
    </LayoutContext>
  )
}
